import { Stack } from "@mui/material";
import NonMHDContinue from "app/frontend/components/eligibility/accordions/confirmation/NonMHDContinue";
import { useMemo } from "react";

export const useProjectConfirmationMicromobility = () => {
    const body = useMemo(() => {
        return (
            <Stack direction={"column"} gap={1}>
                <NonMHDContinue header="Your project may be eligible for PowerReady Micromobility Incentives. Visit the Incentive Calculator to learn more." />
            </Stack>
        );
    }, []);

    return () => ({
        h2: "You May Be Eligible for PowerReady Micromobility Incentives.",
        body: body,
    });
};
